import { Button, Card, message } from 'antd';
import { useState } from 'react';
import { DownloadOutlined } from '../../icons';
import { ApiError } from '../../lib/http';
import { exportExcel } from '../../services/resources';

const CARDS = [
  { resource: 'reservations', title: '预约' },
  { resource: 'experiment-requests', title: '申请' },
  { resource: 'enrollments', title: '报名' },
  { resource: 'users', title: '用户' },
];

export function AdminExportPage() {
  const [busy, setBusy] = useState<string | null>(null);

  return (
    <div className="stack">
      <h1 className="page-title">数据导出</h1>
      <div className="counts">
        {CARDS.map((c) => (
          <Card key={c.resource} title={c.title}>
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              className="touch"
              loading={busy === c.resource}
              onClick={async () => {
                setBusy(c.resource);
                try {
                  await exportExcel(c.resource);
                } catch (e) {
                  message.error(e instanceof ApiError ? e.message : '导出失败');
                } finally {
                  setBusy(null);
                }
              }}
            >
              导出 Excel
            </Button>
          </Card>
        ))}
      </div>
    </div>
  );
}
